import { Link, useLocation, useNavigate } from 'react-router-dom'
import {
	Menu,
	Sun,
	Moon,
	Monitor,
	LogOut,
	User,
	Settings,
} from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
} from '@/components/ui/breadcrumb'
import { useLayoutStore } from '@/stores/layout'
import { useAppStore } from '@/stores/app'
import { useLogout } from '@/hooks/useAuth'
import { useTheme } from '@/hooks/useTheme'
import { useIsMobile } from '@/hooks/useMediaQuery'
import { DepositBadge } from './DepositBadge'

// 面包屑配置
interface BreadcrumbConfig {
	[key: string]: string
}

const breadcrumbConfig: BreadcrumbConfig = {
	'/dashboard': '控制台',
	'/users': '用户管理',
	'/users/list': '用户列表',
	'/users/roles': '角色权限',
	'/users/distributors': '分销商管理',
	'/users/departments': '部门管理',
	'/users/departments/:id': '部门详情',
	'/customers': '客户管理',
	'/customers/gifts': '送礼管理',
	'/customers/service-records': '服务记录',
	'/customers/service-statistics': '服务统计',
	'/customers/department-service-statistics': '部门服务统计',
	'/reports': '报表中心',
	'/reports/sales': '销售报表',
	'/reports/users': '用户报表',
	'/reports/products': '商品报表',
	'/settings': '系统设置',
	'/settings/basic': '基础设置',
	'/settings/payment': '支付配置',
	'/settings/logistics': '物流配置',
	'/settings/audit-logs': '操作日志',
	'/profile': '个人中心',
	'/settings/account': '账户设置',
	'/supplier': '供应商',
	'/supplier/orders': '订单管理',
	'/supplier/refunds': '退款管理',
	'/supplier/deposit': '保证金明细',
	'/admin': '管理后台',
	'/admin/orders': '订单管理',
	'/admin/orders/create': '创建订单',
	'/employee': '员工中心',
	'/employee/orders': '我的订单',
	'/employee/manual-orders': '手动订单',
	'/commissions': '佣金管理',
	'/commissions/my': '我的佣金',
	'/commissions/department': '部门佣金',
	'/data-cube': '数据魔方',
	'/data-cube/records': '数据明细',
	'/data-cube/user-summary': '个人数据统计',
	'/data-cube/user-weight': '员工权重',
	'/data-cube/department-summary': '部门数据统计',
	'/store': '仓库管理',
	'/store/gift-products': '礼物管理',
	'/store/materials': '素材库',
	'/store/products': '商品管理',
}

// TODO: 暂时隐藏搜索框和通知，取消注释即可恢复
// 搜索框组件
// function GlobalSearch() {
// 	const [isFocused, setIsFocused] = useState(false)
// 	const isMobile = useIsMobile()
//
// 	if (isMobile) {
// 		return (
// 			<Button variant="ghost" size="icon" className="shrink-0">
// 				<Search className="h-5 w-5" />
// 				<span className="sr-only">搜索</span>
// 			</Button>
// 		)
// 	}
//
// 	return (
// 		<div className={cn(
// 			"relative flex items-center transition-all duration-200",
// 			isFocused ? "w-72" : "w-60"
// 		)}>
// 			<Search className="absolute left-3 h-4 w-4 text-muted-foreground pointer-events-none" />
// 			<Input
// 				type="search"
// 				placeholder="搜索功能、数据..."
// 				className="pl-9 h-9 bg-muted/50 border-0 focus-visible:ring-1"
// 				onFocus={() => setIsFocused(true)}
// 				onBlur={() => setIsFocused(false)}
// 			/>
// 			<kbd className="absolute right-3 pointer-events-none hidden h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium opacity-100 sm:flex">
// 				<span className="text-xs">⌘</span>K
// 			</kbd>
// 		</div>
// 	)
// }
//
// // 通知下拉菜单
// function NotificationDropdown() {
// 	const notifications = [
// 		{ id: 1, title: '新订单待处理', time: '5分钟前', unread: true },
// 		{ id: 2, title: '用户#1024 完成注册', time: '15分钟前', unread: true },
// 		{ id: 3, title: '退款申请待审核', time: '1小时前', unread: false },
// 		{ id: 4, title: '系统更新完成', time: '2小时前', unread: false },
// 		{ id: 5, title: '月度报表已生成', time: '昨天', unread: false },
// 	]
//
// 	const unreadCount = notifications.filter(n => n.unread).length
//
// 	return (
// 		<DropdownMenu>
// 			<DropdownMenuTrigger asChild>
// 				<Button variant="ghost" size="icon" className="relative shrink-0">
// 					<Bell className="h-5 w-5" />
// 					{unreadCount > 0 && (
// 						<span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-destructive px-1 text-[10px] font-medium text-destructive-foreground">
// 							{unreadCount}
// 						</span>
// 					)}
// 					<span className="sr-only">通知</span>
// 				</Button>
// 			</DropdownMenuTrigger>
// 			<DropdownMenuContent align="end" className="w-80">
// 				<DropdownMenuLabel className="flex items-center justify-between">
// 					<span>通知</span>
// 					{unreadCount > 0 && (
// 						<span className="text-xs font-normal text-muted-foreground">
// 							{unreadCount} 条未读
// 						</span>
// 					)}
// 				</DropdownMenuLabel>
// 				<DropdownMenuSeparator />
// 				<div className="max-h-[300px] overflow-y-auto">
// 					{notifications.map((notification) => (
// 						<DropdownMenuItem
// 							key={notification.id}
// 							className="flex flex-col items-start gap-1 p-3 cursor-pointer"
// 						>
// 							<div className="flex items-center gap-2">
// 								{notification.unread && (
// 									<span className="h-2 w-2 rounded-full bg-accent shrink-0" />
// 								)}
// 								<span className={cn(
// 									"text-sm",
// 									notification.unread ? "font-medium" : "text-muted-foreground"
// 								)}>
// 									{notification.title}
// 								</span>
// 							</div>
// 							<span className="text-xs text-muted-foreground pl-4">
// 								{notification.time}
// 							</span>
// 						</DropdownMenuItem>
// 					))}
// 				</div>
// 				<DropdownMenuSeparator />
// 				<DropdownMenuItem className="justify-center text-accent cursor-pointer">
// 					查看全部通知
// 				</DropdownMenuItem>
// 			</DropdownMenuContent>
// 		</DropdownMenu>
// 	)
// }

// 主题切换
function ThemeToggle() {
	const { theme, setTheme } = useTheme()

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button variant="ghost" size="icon" className="shrink-0">
					<Sun className="h-5 w-5 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
					<Moon className="absolute h-5 w-5 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
					<span className="sr-only">切换主题</span>
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end">
				<DropdownMenuItem onClick={() => setTheme('light')}>
					<Sun className="mr-2 h-4 w-4" />
					<span>浅色</span>
					{theme === 'light' && <span className="ml-auto text-accent">✓</span>}
				</DropdownMenuItem>
				<DropdownMenuItem onClick={() => setTheme('dark')}>
					<Moon className="mr-2 h-4 w-4" />
					<span>深色</span>
					{theme === 'dark' && <span className="ml-auto text-accent">✓</span>}
				</DropdownMenuItem>
				<DropdownMenuItem onClick={() => setTheme('system')}>
					<Monitor className="mr-2 h-4 w-4" />
					<span>跟随系统</span>
					{theme === 'system' && <span className="ml-auto text-accent">✓</span>}
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	)
}

// 用户菜单
function UserMenu() {
	const navigate = useNavigate()
	const user = useAppStore((state) => state.user)
	const clearCache = useLogout()

	const handleLogout = () => {
		// 清除 localStorage token 和 queryClient 缓存
		clearCache()
		// 清除 zustand persisted 状态
		localStorage.removeItem('carrot-admin-store')
		navigate('/login')
	}

	// 获取用户名首字母
	const getInitials = (name: string) => {
		return name ? name.charAt(0).toUpperCase() : 'U'
	}

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button variant="ghost" className="relative h-9 gap-2 px-2">
					<Avatar className="h-7 w-7">
						<AvatarImage src={user.user?.avatar} alt={user.user?.username || 'User'} />
						<AvatarFallback className="text-xs bg-primary text-primary-foreground">
							{getInitials(user.user?.username || 'A')}
						</AvatarFallback>
					</Avatar>
					<div className="hidden md:flex flex-col items-start">
						<span className="text-sm font-medium">{user.user?.username || 'Admin'}</span>
						<span className="text-xs text-muted-foreground">{user.user?.roleName || '管理员'}</span>
					</div>
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end" className="w-56">
				<DropdownMenuLabel>
					<div className="flex flex-col space-y-1">
						<p className="text-sm font-medium">{user.user?.username}</p>
						<p className="text-xs text-muted-foreground">{user.user?.email}</p>
					</div>
				</DropdownMenuLabel>
				<DropdownMenuSeparator />
				<DropdownMenuItem onClick={() => navigate('/profile')}>
					<User className="mr-2 h-4 w-4" />
					<span>个人资料</span>
				</DropdownMenuItem>
				<DropdownMenuItem onClick={() => navigate('/settings/account')}>
					<Settings className="mr-2 h-4 w-4" />
					<span>账户设置</span>
				</DropdownMenuItem>
				<DropdownMenuSeparator />
				<DropdownMenuItem
					className="text-destructive focus:text-destructive cursor-pointer"
					onClick={handleLogout}
				>
					<LogOut className="mr-2 h-4 w-4" />
					<span>退出登录</span>
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	)
}

// 面包屑导航
function AppBreadcrumb() {
	const location = useLocation()
	const isMobile = useIsMobile()

	// 移动端不显示面包屑
	if (isMobile) return null

	// 解析当前路径
	const pathSegments = location.pathname.split('/').filter(Boolean)

	// 动态路由模式配置：key 是正则，value 是替换后的 label
	const dynamicRoutePatterns: Array<{ pattern: RegExp; label: string; parentPath: string }> = [
		{ pattern: /^\/users\/departments\/\d+$/, label: '部门详情', parentPath: '/users/departments' },
	]

	// 构建面包屑路径
	const breadcrumbs: Array<{ path: string; label: string }> = []
	let currentPath = ''

	pathSegments.forEach((segment, index) => {
		currentPath = '/' + pathSegments.slice(0, index + 1).join('/')

		// 检查是否是动态路由（数字 ID）
		const isNumericId = /^\d+$/.test(segment)

		if (isNumericId && index > 0) {
			// 对于数字 ID，查找父路径的配置
			const parentPath = '/' + pathSegments.slice(0, index).join('/')
			const dynamicPattern = dynamicRoutePatterns.find(p => currentPath.match(p.pattern))
			if (dynamicPattern) {
				breadcrumbs.push({
					path: currentPath,
					label: dynamicPattern.label,
				})
			} else {
				// 默认跳过数字 ID 段，使用父路径的名称
				breadcrumbs.push({
					path: currentPath,
					label: breadcrumbConfig[parentPath] || segment,
				})
			}
		} else {
			breadcrumbs.push({
				path: currentPath,
				label: breadcrumbConfig[currentPath] || segment,
			})
		}
	})

	// 添加首页（如果当前不是首页）
	if (location.pathname !== '/dashboard') {
		breadcrumbs.unshift({ path: '/dashboard', label: '首页' })
	}

	return (
		<Breadcrumb>
			<BreadcrumbList>
				{breadcrumbs.map((crumb, index) => (
					<BreadcrumbItem key={crumb.path}>
						{index < breadcrumbs.length - 1 ? (
							<>
								<BreadcrumbLink asChild>
									<Link to={crumb.path}>{crumb.label}</Link>
								</BreadcrumbLink>
								<BreadcrumbSeparator />
							</>
						) : (
							<BreadcrumbPage>{crumb.label}</BreadcrumbPage>
						)}
					</BreadcrumbItem>
				))}
			</BreadcrumbList>
		</Breadcrumb>
	)
}

// 顶部导航栏
export function TopNavbar() {
	const { toggleMobileSidebar } = useLayoutStore()
	const isMobile = useIsMobile()

	return (
		<header className="sticky top-0 z-40 flex h-14 items-center gap-4 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 px-4 md:px-6">
			{/* 移动端菜单按钮 */}
			{isMobile && (
				<Button
					variant="ghost"
					size="icon"
					onClick={toggleMobileSidebar}
					className="shrink-0"
				>
					<Menu className="h-5 w-5" />
					<span className="sr-only">打开菜单</span>
				</Button>
			)}

			{/* 面包屑导航 */}
			<div className="flex-1">
				<AppBreadcrumb />
			</div>

			{/* 右侧操作区 */}
			<div className="flex items-center gap-2">
				{/* TODO: 暂时隐藏全局搜索 */}
				{/* <GlobalSearch /> */}

				{/* TODO: 暂时隐藏通知 */}
				{/* <NotificationDropdown /> */}

				{/* 保证金余额（仅供应商可见） */}
				<DepositBadge />

				{/* 主题切换 */}
				<ThemeToggle />

				{/* 用户菜单 */}
				<UserMenu />
			</div>
		</header>
	)
}
